(function(){
  'use strict';
  var KEY='__AV_MOBILE_MENU_FINAL_V10__';
  if(window[KEY]) return;
  window[KEY]=true;

  var FOCUSABLE='a[href],area[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var activeRoot=null;
  var activeTrigger=null;
  var lastFocus=null;
  var lockedY=0;
  var oldBodyStyle=null;

  function isDesktop(){return window.matchMedia && window.matchMedia('(min-width: 990px)').matches;}
  function visible(el){return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));}
  function roots(){return Array.prototype.slice.call(document.querySelectorAll('[data-av-mobile-menu]'));}
  function firstRoot(){return roots()[0] || null;}
  function removeDuplicateAvMenus(){
    var all=roots();
    if(all.length<=1) return;
    all.slice(1).forEach(function(el){
      try{el.parentNode && el.parentNode.removeChild(el);}catch(e){
        el.setAttribute('hidden','');
        el.setAttribute('aria-hidden','true');
        try{el.setAttribute('inert','');}catch(_e){}
      }
    });
  }
  function removeLegacyMobileDrawers(){
    if(isDesktop()) return;
    var legacySelectors=[
      '.mobile-sliderule',
      '.sliderule__wrapper',
      '.mobile__menu__dropdown',
      '[data-drawer="hamburger"]',
      '[data-drawer-target="hamburger"]',
      '#header-menu',
      '.js-drawer-open-left',
      '.drawer--left',
      '.drawer__inner .mobile-menu',
      '[data-legacy-mobile-menu]'
    ];
    legacySelectors.forEach(function(sel){
      Array.prototype.slice.call(document.querySelectorAll(sel)).forEach(function(el){
        if(el.closest('[data-av-mobile-menu]')) return;
        if(el.closest('header-component') || el.matches('#header-menu,.drawer--left,.mobile-sliderule,.sliderule__wrapper,.mobile__menu__dropdown,[data-legacy-mobile-menu]')){
          try{el.parentNode && el.parentNode.removeChild(el);}catch(e){
            el.setAttribute('hidden','');
            el.setAttribute('aria-hidden','true');
            try{el.setAttribute('inert','');}catch(_e){}
          }
        }
      });
    });
  }
  function auditEmptyHeaderLinks(){
    var scope=document.querySelector('header-component') || document;
    Array.prototype.slice.call(scope.querySelectorAll('a')).forEach(function(a){
      if((a.textContent||'').trim() || a.getAttribute('aria-label') || a.getAttribute('title')) return;
      if(a.matches('[data-logo-link],.header__logo__link')) a.setAttribute('aria-label','Australia Vibes - página inicial');
      else if(a.matches('[href*="/search"],.navlink--search')) a.setAttribute('aria-label','Abrir busca');
      else if(a.matches('[href*="/cart"],[data-cart-toggle],.navlink--cart')) a.setAttribute('aria-label','Abrir carrinho');
      else if(a.getAttribute('href')==='#' || !a.getAttribute('href')){
        try{a.parentNode && a.parentNode.removeChild(a);}catch(e){a.setAttribute('aria-hidden','true');a.setAttribute('tabindex','-1');}
      }
    });
  }
  function openers(){return Array.prototype.slice.call(document.querySelectorAll('[data-av-mobile-menu-open],[data-av-mobile-menu-focus-search]'));}
  function focusables(root){
    return Array.prototype.slice.call(root.querySelectorAll(FOCUSABLE)).filter(function(el){
      return !el.hasAttribute('hidden') && !el.closest('[hidden]') && visible(el);
    });
  }
  function setInert(el, value){
    try{
      if(value){el.setAttribute('inert','');}
      else{el.removeAttribute('inert');}
    }catch(e){}
  }
  function setOpeners(root, open){
    openers().forEach(function(btn){
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(root && root.id) btn.setAttribute('aria-controls', root.id);
    });
  }
  function lockScroll(){
    if(oldBodyStyle) return;
    lockedY=window.scrollY || document.documentElement.scrollTop || 0;
    oldBodyStyle={position:document.body.style.position, top:document.body.style.top, width:document.body.style.width, overflow:document.body.style.overflow};
    document.documentElement.classList.add('av-mobile-menu-open');
    document.body.classList.add('av-mobile-menu-open');
    document.body.style.position='fixed';
    document.body.style.top='-'+lockedY+'px';
    document.body.style.width='100%';
    document.body.style.overflow='hidden';
  }
  function unlockScroll(){
    document.documentElement.classList.remove('av-mobile-menu-open');
    document.body.classList.remove('av-mobile-menu-open');
    if(oldBodyStyle){
      document.body.style.position=oldBodyStyle.position || '';
      document.body.style.top=oldBodyStyle.top || '';
      document.body.style.width=oldBodyStyle.width || '';
      document.body.style.overflow=oldBodyStyle.overflow || '';
    }
    window.scrollTo(0, lockedY || 0);
    oldBodyStyle=null;
  }
  function initIntent(root){
    var input=root.querySelector('[data-av-mobile-search-input]');
    var list=root.querySelector('[data-av-mobile-intents]');
    if(!input || !list || input.dataset.avIntentReady==='true') return;
    input.dataset.avIntentReady='true';
    var rows=Array.prototype.slice.call(list.querySelectorAll('[data-av-mobile-intent]'));
    function normalize(v){return (v||'').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,'-');}
    function currentQuery(){
      var q=input.value || '';
      if(!q){
        try{ q=(new URLSearchParams(window.location.search)).get('q') || ''; }catch(e){}
      }
      return q;
    }
    function tokenMatch(q, terms){
      if(!q || !terms) return false;
      var parts=terms.split('-');
      if(terms.indexOf(q)!==-1 || q.indexOf(terms)!==-1) return true;
      for(var i=0;i<parts.length;i++){
        if(parts[i] && q.indexOf(parts[i])!==-1) return true;
      }
      return false;
    }
    function update(){
      var q=normalize(currentQuery());
      rows.forEach(function(row){row.classList.remove('is-active'); row.removeAttribute('aria-current'); row.style.order='';});
      if(!q) return;
      var matched=false;
      rows.forEach(function(row){
        if(matched) return;
        var terms=normalize(row.getAttribute('data-av-mobile-intent'));
        if(tokenMatch(q, terms)){
          row.classList.add('is-active');
          row.setAttribute('aria-current','true');
          row.style.order='-1';
          matched=true;
        }
      });
    }
    input.addEventListener('input', update);
    input.addEventListener('change', update);
    update();
  }
  function openMenu(root, trigger, focusSearch){
    if(!root || isDesktop()) return;
    if(activeRoot && activeRoot !== root) closeMenu(activeRoot, false);
    activeRoot=root;
    activeTrigger=trigger || openers()[0] || null;
    lastFocus=document.activeElement;
    root.hidden=false;
    root.setAttribute('aria-hidden','false');
    setInert(root,false);
    setOpeners(root,true);
    lockScroll();
    requestAnimationFrame(function(){root.classList.add('is-open');});
    setTimeout(function(){
      var target=focusSearch ? root.querySelector('[data-av-mobile-search-input]') : null;
      target = target || root.querySelector('[data-av-mobile-menu-close]') || root.querySelector('[data-av-mobile-menu-panel]') || root;
      if(target && target.focus) target.focus({preventScroll:true});
    },60);
  }
  function closeMenu(root, returnFocus){
    root=root || activeRoot;
    if(!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden','true');
    setOpeners(root,false);
    unlockScroll();
    var trigger=activeTrigger || lastFocus;
    setTimeout(function(){
      root.hidden=true;
      setInert(root,true);
      if(returnFocus !== false && trigger && trigger.focus) trigger.focus({preventScroll:true});
    }, window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180);
    activeRoot=null; activeTrigger=null; lastFocus=null;
  }
  function toggleAccordion(button){
    var root=button.closest('[data-av-mobile-menu]');
    var id=button.getAttribute('aria-controls');
    var panel=id ? document.getElementById(id) : null;
    if(!root || !panel) return;
    var open=button.getAttribute('aria-expanded')==='true';
    root.querySelectorAll('[data-av-mobile-accordion]').forEach(function(btn){
      var pid=btn.getAttribute('aria-controls');
      var p=pid ? document.getElementById(pid) : null;
      btn.setAttribute('aria-expanded','false');
      if(p) p.hidden=true;
    });
    if(!open){button.setAttribute('aria-expanded','true'); panel.hidden=false;}
  }
  function init(root){
    if(!root || root.dataset.avMobileReady==='true') return;
    root.dataset.avMobileReady='true';
    root.setAttribute('aria-hidden','true');
    if(!root.id) root.id='av-mobile-menu';
    setInert(root,true);
    root.hidden=true;
    root.querySelectorAll('[data-av-mobile-menu-close]').forEach(function(btn){btn.addEventListener('click', function(){closeMenu(root,true);});});
    root.querySelectorAll('[data-av-mobile-accordion]').forEach(function(btn){btn.addEventListener('click', function(){toggleAccordion(btn);});});
    initIntent(root);
  }
  function initAll(){
    removeDuplicateAvMenus();
    removeLegacyMobileDrawers();
    auditEmptyHeaderLinks();
    roots().forEach(init);
    var r=firstRoot();
    if(r) setOpeners(r,false);
  }

  document.addEventListener('click', function(e){
    var opener=e.target.closest('[data-av-mobile-menu-open],[data-av-mobile-menu-focus-search]');
    if(opener){
      var root=firstRoot();
      if(root){e.preventDefault(); openMenu(root, opener, opener.hasAttribute('data-av-mobile-menu-focus-search'));}
      return;
    }
    var close=e.target.closest('[data-av-mobile-menu-close]');
    if(close){var r=close.closest('[data-av-mobile-menu]') || activeRoot; if(r){e.preventDefault(); closeMenu(r,true);}}
  });
  document.addEventListener('keydown', function(e){
    if(!activeRoot) return;
    if(e.key==='Escape'){e.preventDefault(); closeMenu(activeRoot,true); return;}
    if(e.key!=='Tab') return;
    var nodes=focusables(activeRoot);
    if(!nodes.length) return;
    var first=nodes[0], last=nodes[nodes.length-1];
    if(e.shiftKey && document.activeElement===first){e.preventDefault(); last.focus();}
    else if(!e.shiftKey && document.activeElement===last){e.preventDefault(); first.focus();}
  });
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function(e){if(activeRoot && e.target && e.target.contains(activeRoot)) closeMenu(activeRoot,false);});
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
})();
